import assets from './static-assets.json';

export function isWorkspaceStaticIcon(source: string): boolean {
  return Object.values(assets).some(
    (path) => path.startsWith('/workspace/icons/') && path === source
  );
}

/** Local files are authoritative for these migrated Workspace media assets. */
export function resolveWorkspaceStaticAsset(source: string): string {
  const key = source.replace(
    /^https:\/\/storage\.(?:imgenhancer\.app|staging\.centuryseries\.(?:buzz|org))\//,
    ''
  );
  return Object.hasOwn(assets, key)
    ? assets[key as keyof typeof assets]
    : source;
}
